import { Dialogs } from '@leverege/ui-elements';
import { DataSources, Attributes } from '@leverege/ui-attributes';
import SalesFlow from '../../views/salesFlow/SalesFlow';
import C from '../../views/salesFlow/Constants';
const objectType = 'vehicle';
const id = 'recovr.salesFlow';

// Vehicle Only Sale
const vehicleOnlyAction = {
  handles: hasAnyVehicleWithNoPendingLocator,
  appearance: ({
    context
  }) => ({
    name: `Vehicle Only Sale (${getLabelFromTarget(context)})`
  }),
  perform: props => {
    const {
      context
    } = props;
    const vehicles = getVehiclesWithNoPendingLocator(context);
    Dialogs.show({
      id: C.SALE_TYPES.VEHICLE_ONLY,
      component: SalesFlow,
      props: {
        ...props,
        vehicles,
        saleType: C.SALE_TYPES.VEHICLE_ONLY
      }
    });
  }
};
const actions = [
// RecovR & Vehicle Sale
{
  handles: hasSingleVehicleWithNoPendingLocator,
  appearance: () => ({
    name: 'RecovR & Vehicle Sale'
  }),
  perform: props => {
    const {
      context: {
        target = []
      }
    } = props;
    const vehicle = target?.[0];
    const actions = DataSources.getActions(vehicle);
    const locationActions = actions.parent().parent();
    const locationData = locationActions.getItem();
    const location = {
      data: locationData,
      id: locationData?.id,
      ref: locationActions.getInterfaceUrl(),
      type: 'location'
    };
    Dialogs.show({
      id: C.SALE_TYPES.VEHICLE_WITH_LOCATOR,
      component: SalesFlow,
      props: {
        ...props,
        vehicle,
        location,
        actions,
        saleType: C.SALE_TYPES.VEHICLE_WITH_LOCATOR
      }
    });
  }
}, vehicleOnlyAction,
// Vehicle Wholesale
{
  handles: hasAnyVehicleWithNoPendingLocator,
  appearance: ({
    context
  }) => ({
    name: `Vehicle Wholesale (${getLabelFromTarget(context)})`
  }),
  perform: props => {
    const {
      context
    } = props;
    const vehicles = getVehiclesWithNoPendingLocator(context);
    Dialogs.show({
      id: C.SALE_TYPES.VEHICLE_WHOLESALE,
      component: SalesFlow,
      props: {
        ...props,
        vehicles,
        saleType: C.SALE_TYPES.VEHICLE_WHOLESALE
      }
    });
  }
},
// Dealer Trade
{
  handles: hasAnyVehicleWithNoPendingLocator,
  appearance: ({
    context
  }) => ({
    name: `Dealer Trade (${getLabelFromTarget(context)})`
  }),
  perform: props => {
    const {
      context
    } = props;
    const vehicles = getVehiclesWithNoPendingLocator(context);
    Dialogs.show({
      id: C.SALE_TYPES.DEALER_TRADE,
      component: SalesFlow,
      props: {
        ...props,
        vehicles,
        saleType: C.SALE_TYPES.DEALER_TRADE
      }
    });
  }
}];
export default {
  id,
  name: 'Sell a Vehicle',
  layout: {
    sort: 'vehicle.sell',
    sectionName: 'Sales'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['location.vehicles', 'company.locations.vehicles'],
    objectType: 'vehicle'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: hasAnyVehicleWithNoPendingLocator,
  getActions(cxt) {
    // Only show the sale dropdowns if the user has the correct role and is allowed to sell the vehicle
    if (!this.handles(cxt)) {
      return [];
    }
    const vehicleOnlyEnabled = window.Molten.getConfig('actions')?.[id]?.vehicleOnly;
    return [{
      type: 'layoutNode',
      name: 'Mark as Sold',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/sales-flow-action.png',
      items: vehicleOnlyEnabled ? [vehicleOnlyAction] : actions
    }];
  }
};

/**
 * Get label describing the quantity of targets with no pending locator.
 */
function getLabelFromTarget(cxt) {
  const vehicles = getVehiclesWithNoPendingLocator(cxt);
  if (vehicles.length === 1) {
    return `${vehicles.length} Vehicle`;
  }
  return `${vehicles.length} Vehicles`;
}

/**
 * Check if the target list has exactly 1 vehicle with no pending locator.
 */
function hasSingleVehicleWithNoPendingLocator(cxt) {
  return getVehiclesWithNoPendingLocator(cxt).length === 1;
}

/**
 * Check if the target list has any vehicle with no pending locator.
 */
function hasAnyVehicleWithNoPendingLocator(cxt) {
  return getVehiclesWithNoPendingLocator(cxt).length > 0;
}

/**
 * Filter target list for vehicles with no pending locators.
 */
function getVehiclesWithNoPendingLocator(cxt) {
  const targets = cxt?.target || [];
  return targets.filter(target => {
    if (target?.type !== objectType) {
      return false;
    }
    const saleState = Attributes.get('vehicle.saleState', 'vehicle', target?.data);
    return saleState !== C.VEHICLE_SALE_STATES.PENDING_REMOVE_LOCATOR && saleState !== C.VEHICLE_SALE_STATES.PENDING_REPLACE_LOCATOR;
  });
}